import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FileType } from '@fi-shared/types';
import { fiGetMediaBankFileIconAwesome } from '@fi-shared/utils';
import { safeStartsWith } from '@fi-shared/utils/safe-starts-with';

@Component({
    selector: 'fi-file-preview',
    template: `
        @if (imageSrc) {
          <span class="preview-image" [style.background-image]="'url(' + imageSrc + ')'"></span>
        }
        
        @if (!imageSrc) {
          <span class="preview-icon fa fa-2x" [ngClass]="iconClass"></span>
        }
        `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./file-preview.component.scss'],
    host: { class: 'fi-file-preview' },
    standalone: false,
})
export class FiFilePreviewComponent implements OnInit {
    constructor(private cdr: ChangeDetectorRef) {}

    @Input() previewFile: File;

    iconClass: string;
    imageSrc: string;

    private extIconMap: { [prop: number]: string[] } = {};

    ngOnInit() {
        this.extIconMap[FileType.Pdf] = ['pdf'];
        this.extIconMap[FileType.Audio] = [
            'aa',
            'aac',
            'aax',
            'act',
            'aiff',
            'amr',
            'ape',
            'au',
            'awb',
            'dct',
            'dss',
            'dvf',
            'flac',
            'gsm',
            'iklax',
            'ivs',
            'm4a',
            'm4b',
            'mmf',
            'mp3',
            'mpc',
            'msv',
            'ogg',
            'oga',
            'opus',
            'ra',
            'raw',
            'sln',
            'tta',
            'vox',
            'wav',
            'wma',
            'wv',
        ];
        this.extIconMap[FileType.MsWord] = ['doc', 'docx'];
        this.extIconMap[FileType.Document] = ['txt', 'html'];
        this.extIconMap[FileType.Excel] = ['xls', 'xlsx'];
        this.extIconMap[FileType.PowerPoint] = ['ppt', 'pptx'];
        this.extIconMap[FileType.Movie] = [
            'webm',
            'mkv',
            'flv',
            'vob',
            'ogv',
            'drc',
            'avi',
            'mov',
            'qt',
            'wmv',
            'yuv',
            'rm',
            'rmvb',
            'mp4',
            'm4p',
            'm4v',
            'mpg',
            'mp2',
            'mpeg',
            'mpe',
            'mpv',
            'm4v',
            'svi',
            '3gp',
            '3g2',
            'mxf',
            'nsv',
        ];
        this.extIconMap[FileType.Compressed] = ['zip', 'rar', 'tar', '7z', 'gz', 'iso'];
        this.extIconMap[FileType.JavaScript] = ['js', 'css', 'scss', 'less'];

        let match: RegExpMatchArray;
        if (safeStartsWith(this.previewFile.type, 'image/')) {
            this.iconClass = fiGetMediaBankFileIconAwesome(FileType.Image);
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageSrc = e.target.result;
                this.cdr.detectChanges();
            };
            reader.readAsDataURL(this.previewFile);
        } else if ((match = this.previewFile.name.match(/\.([\w\d]+)$/))) {
            this.iconClass = this.getIconClass(match[1]);
        }
    }

    private getIconClass(ext: string) {
        for (let key in this.extIconMap) {
            if (this.extIconMap.hasOwnProperty(key) && this.extIconMap[key].indexOf(ext) > -1) {
                return fiGetMediaBankFileIconAwesome(parseInt(key));
            }
        }

        return fiGetMediaBankFileIconAwesome(FileType.Unknown);
    }
}
